import type { RefObject } from "react";
import { spaceHomeHeroLayoutCssVars } from "../Config";
import type { GetHomeDataResult, MembershipProduct, SpaceProfile } from "../SpaceType";
import { SpaceHomeInfoSection } from "./SpaceHomeInfoSection";
import { SpaceHomeProductPreview } from "./SpaceHomeProductPreview";
import { SpaceHomeSubscribeCards } from "./SpaceHomeSubscribeCards";

/** 空间首页布局 */
export function SpaceHomePage(props: {
  spaceId: string;
  spaceProfile: SpaceProfile | null;
  homeData: GetHomeDataResult | null;
  membershipProducts: MembershipProduct[];
  isLoggedIn: boolean;
  favorStatus: 0 | 1;
  membershipListRef: RefObject<HTMLUListElement>;
  onLoginRequest: () => void;
  onFollow: () => void;
  onRequestUnfollow: () => void;
  onSubscribeScroll: () => void;
}): JSX.Element {
  const {
    spaceId,
    spaceProfile,
    homeData,
    membershipProducts,
    isLoggedIn,
    favorStatus,
    membershipListRef,
    onLoginRequest,
    onFollow,
    onRequestUnfollow,
    onSubscribeScroll,
  } = props;

  return (
    <div className="space-home" style={spaceHomeHeroLayoutCssVars()}>
      {/* 空间信息 + 按钮 */}
      {spaceProfile ? (
        <SpaceHomeInfoSection
          profile={spaceProfile}
          isLoggedIn={isLoggedIn}
          favorStatus={favorStatus}
          onLoginRequest={onLoginRequest}
          onFollow={onFollow}
          onRequestUnfollow={onRequestUnfollow}
          onSubscribe={onSubscribeScroll}
        />
      ) : null}

      {/* 产品预览 */}
      <SpaceHomeProductPreview
        spaceId={spaceId}
        data={homeData}
        membershipProducts={membershipProducts}
      />

      {/* 订阅卡片 */}
      <SpaceHomeSubscribeCards
        spaceId={spaceId}
        products={membershipProducts}
        isLoggedIn={isLoggedIn}
        spaceProfile={spaceProfile}
        listRef={membershipListRef}
        onLoginRequest={onLoginRequest}
      />
    </div>
  );
}
